import { render, staticRenderFns } from "./ChangeGroupOwnerDialog.vue?vue&type=template&id=da89673a&"
import script from "./ChangeGroupOwnerDialog.vue?vue&type=script&lang=ts&"
export * from "./ChangeGroupOwnerDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports